import { promotionsService } from 'shared/src/api';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';

export const useGoodsPromotionComponents = (
  screen: 'GOODS_DETAIL' | 'GOODS_OPTION_MODAL',
) => {
  const goodsSno = useGoodsSno();

  return useSuspenseQuery({
    queryKey: queryKey.promotionsComponents(goodsSno, screen),
    queryFn: () => promotionsService.getPromotionsComponents(goodsSno, screen),
  });
};
